import { render } from "./Stores.vue?vue&type=template&id=20ba36b8&scoped=true"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"

import "./Stores.vue?vue&type=style&index=0&id=20ba36b8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ba36b8"]])

export default __exports__